import { FeatureFlag, ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.UPLOAD_BULK_TRANSPORT_SERVICES}
		>
			<FeatureFlag flag="add_quote_cab_prices_at_once" show404>
				<Outlet />
			</FeatureFlag>
		</ForbidUnlessAuthorized>
	)
}
